import Dashboard from "../pages/Dashboard";
import PowerSource from "../pages/PowerSource";
import Login from "../pages/Login";

export const routes = [
  {
    path: "/login",
    component: Login,
    exact: true,
    name: "Login",
    id: "login",
  },
  {
    path: "/dashboard",
    component: Dashboard,
    exact: true,
    name: "Dashboard",
    icon: "📊",
    id: "dashboard",
  },
  {
    path: "/power-source/:id",
    component: PowerSource,
    exact: true,
    name: "Güç Kaynağı",
    icon: "⚡",
    id: "power-source",
  },
];

export default routes;
